import { lazy } from "react";

export type { Year, Years, YearControlProps } from "./YearControl.component";

export const YearControl = lazy(() => import("./YearControl.component"));
